import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit';
import {
  dailyWorkdayDurationInitialState,
  dailyWorkdayDurationReducers,
} from '../modules/dailyWorkdayDuration/slices/daily-workday-duration.slice';
import {
  visitedLocationsInitialState,
  visitedLocationsReducers,
} from '../modules/visitedLocations/slices/visited-locations-slice';
import {
  conditionalEventsInitialState,
  conditionalEventsReducers,
} from '../modules/conditionalEvents/slices/conditional-events-slice';
import {
  vehicleGeofenceInitialState,
  vehicleGeofenceReducers,
} from '../modules/vehicleGeofence/slices/vehicle-geofence-slice';
import { ReportsSlice, ReportType } from '../types';
import { VisitedLocationsReportSlice } from '../modules/visitedLocations/types';
import { DailyWorkdayDurationReportSlice } from '../modules/dailyWorkdayDuration/types';
import { ConditionalEventsReportSlice } from '../modules/conditionalEvents/types';
import { VehicleGeofenceReportSlice } from '../modules/vehicleGeofence/types';
import { TripsReportSlice } from '../modules/trips/types';
import {
  tripsInitialState,
  tripsReducers,
} from '../modules/trips/slices/trips-slice';

export const initialState: ReportsSlice<
  | VisitedLocationsReportSlice
  | DailyWorkdayDurationReportSlice
  | ConditionalEventsReportSlice
  | VehicleGeofenceReportSlice
  | TripsReportSlice
> = {
  [ReportType.VISITED_LOCATIONS]: visitedLocationsInitialState,
  [ReportType.WORKDAY_DURATION]: dailyWorkdayDurationInitialState,
  [ReportType.CONDITIONAL_EVENTS]: conditionalEventsInitialState,
  [ReportType.GEOFENCES]: vehicleGeofenceInitialState,
  [ReportType.TRIPS]: tripsInitialState,
};

export const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    visitedLocationsReducers(
      builder as ActionReducerMapBuilder<
        ReportsSlice<VisitedLocationsReportSlice>
      >,
    );
    dailyWorkdayDurationReducers(
      builder as ActionReducerMapBuilder<
        ReportsSlice<DailyWorkdayDurationReportSlice>
      >,
    );
    conditionalEventsReducers(
      builder as ActionReducerMapBuilder<
        ReportsSlice<ConditionalEventsReportSlice>
      >,
    );
    vehicleGeofenceReducers(
      builder as ActionReducerMapBuilder<
        ReportsSlice<VehicleGeofenceReportSlice>
      >,
    );
    tripsReducers(
      builder as ActionReducerMapBuilder<ReportsSlice<TripsReportSlice>>,
    );
  },
});
